// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"5f7edfd8","203":"3ab0b938"}[chunkId] + ".chunk.css";
};